import { all, call, put, takeLeading, select } from 'redux-saga/effects';
import { actions, types } from '@src/store';
import { history } from '@src/routes';
import { selectSubscriberId, selectUserPlan, selectSubscriberEmail, selectCurrentProfile } from '@src/store/selectors';
import { requestAddProfile, fetchProfiles } from '@src/apis/Profile';

import analytics from '@src/firebase/analytics';


const logger = Logger.get('profile/saga');

function* profileSaga() {
    yield all([
        takeLeading(types.profile.FetchProfiles, getProfilesList),
        takeLeading(types.profile.CreateProfile, createProfile)
    ]);
}

function* createProfile({ payload }) {
    const subscriberId = yield select(selectSubscriberId);
    const userplan = yield select(selectUserPlan);
    const email = yield select(selectSubscriberEmail);
    const currentprofile = yield select(selectCurrentProfile);
    const level = currentprofile?.currentLevel
    const profileId = currentprofile?.profileid
    try {
        yield put(actions.common.SetLoader(true));

        const { childName: name, ...params } = payload;

        const data = { subscriberId, name, ...params };

        const response = yield call(requestAddProfile, data);


        // analytics.logEvent( 'ADDEDITPROFILE', { Email:email,Level:level,SubscriberID:subscriberId, ProfileID:profileId, Mode:'ADD' , Status : 'SUCCESS',DOB:payload.dob, Gender:payload.gender, City:payload.city, State:payload.state, Country:payload.country  } );

        if (!response.success) throw response;

        yield call(getProfilesList);

        yield put(actions.profile.SelectProfile({ profileid: response.success }));

        yield put(actions.common.SetLoader(false));

        if(!level)
        history.push('/levels', {
            registration: true
        });

        // history.push( '/levels', {
        //     registration: userplan?.plantype !== 'PREMIUM'
        // } );

    }
    catch (error) {
        logger.log(error);
        yield put(actions.common.SetLoader(false));
        const errorData = {
            type: 'addprofile',
            message: error?.reason ?? 'Profile could not be Created!'
        }
        yield put(actions.common.SetError(errorData))

        analytics.logEvent('ADDEDITPROFILE', { Email: email, SubscriberID: subscriberId, Status: 'Failure', ErrorMessage: error.reason, ErrorCode: error.code });
    }
}

export function* getProfilesList({ subscriberId } = {}) {
    try {
        if (!subscriberId) subscriberId = yield select(selectSubscriberId);

        const profiles = yield call(fetchProfiles, { subscriberId });

        if (profiles.length == 0) return history.push('/profiles')

        yield put(actions.profile.SetProfiles({ profiles }));
    }
    catch (error) {
        logger.log(error);
    }
}

export default profileSaga